import { MapLayerProps } from 'features/mapping/mapping.types';
import { useAQIStationsLayerEnabled } from 'features/mapping/hooks/useAQIStationsLayerEnabled';
import { AQILayer } from './AQILayer';
import { LegacyPurpleAirLayer } from './LegacyPurpleAirLayer';

export const PurpleAirLayer = (props: MapLayerProps): JSX.Element => {
  const { visible } = props;
  const aqiStationsLayerEnabled = useAQIStationsLayerEnabled();

  return (
    <>
      <LegacyPurpleAirLayer visible={visible && !aqiStationsLayerEnabled} />
      <AQILayer visible={visible && aqiStationsLayerEnabled} />
    </>
  );
};
